import { render, staticRenderFns } from "./RoundRobinTab.vue?vue&type=template&id=152f280a&"
import script from "./RoundRobinTab.vue?vue&type=script&lang=js&"
export * from "./RoundRobinTab.vue?vue&type=script&lang=js&"
import style0 from "./RoundRobinTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports